import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import axios, { API } from "@/lib/api";

export default function GuidesPreview() {
  const [guides, setGuides] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`${API}/public/guides`).then(({ data }) => setGuides(data.slice(0, 3))).catch(() => {});
  }, []);

  return (
    <section className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8" data-testid="guides-section">
      <div className="mx-auto max-w-2xl text-center">
        <span className="text-sm font-semibold uppercase tracking-wide text-[#1677B8]">Tim Pembimbing</span>
        <h2 className="mt-3 font-heading text-3xl font-bold text-[#1F2937] sm:text-4xl">Pembimbing Berpengalaman</h2>
      </div>

      <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {guides.map((g) => (
          <div key={g.id} data-testid={`guide-card-${g.id}`} className="rounded-2xl bg-white p-6 text-center shadow-[0_2px_16px_rgba(15,107,79,0.06)] transition-all duration-300 hover:-translate-y-1">
            <img src={g.photo_url} alt={g.name} className="mx-auto h-24 w-24 rounded-full object-cover ring-4 ring-[#0F6B4F]/10" />
            <h3 className="mt-4 font-heading text-base font-semibold text-[#1F2937]">{g.name}</h3>
            <p className="text-sm text-[#1677B8]">{g.position}</p>
            <p className="mt-3 text-sm leading-relaxed text-[#64748B] line-clamp-3">{g.bio}</p>
            <Button variant="outline" size="sm" data-testid={`guide-profile-button-${g.id}`} onClick={() => navigate("/pembimbing")} className="mt-4 rounded-full">
              Lihat Profil
            </Button>
          </div>
        ))}
      </div>
    </section>
  );
}
